import React, { useEffect, useState } from "react";

import { useUsersContext } from "../../context/UsersContext";
import UsersMainPage from "../users/UsersMainPage";

const RegisteredUsers = () => {
  const { deactivatedUsers, personalUsers, businessUsers, users } =
    useUsersContext();

  const [allBusinessUsers, setAllBusinessUsers] = useState(businessUsers);
  const [allPersonalUsers, setAllPersonalUsers] = useState(personalUsers);
  const [allUsers, setAllUsers] = useState(users);
  const [allDeactivatedUsers, setAllDeactivatedUsers] =
    useState(deactivatedUsers);

  useEffect(() => {
    setAllPersonalUsers(personalUsers);
    setAllBusinessUsers(businessUsers);
    setAllUsers(users);
    setAllDeactivatedUsers(deactivatedUsers);
  }, [personalUsers, businessUsers, users, deactivatedUsers]);

  return (
    <UsersMainPage
      allPersonalUsers={allPersonalUsers}
      allUsers={allUsers}
      setAllUsers={setAllUsers}
      setAllPersonalUsers={setAllPersonalUsers}
      allBusinessUsers={allBusinessUsers}
      setAllBusinessUsers={setAllBusinessUsers}
      allDeactivatedUsers={allDeactivatedUsers}
      setAllDeactivatedUsers={setAllDeactivatedUsers}
      headerTitle="Registered Users"
    />
  );
};

export default RegisteredUsers;
